/* eslint-disable @nx/enforce-module-boundaries */
import React, {useState, useEffect } from 'react';
import {
  Box,
  Text,
  Image,
  HStack,
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Stack,
  Flex,
  Card,
  CardBody,
  Heading,
  CardFooter,
  Divider,
  Spacer,
  Tooltip,
  useToast
} from '@mybridge/ui';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import {
  CalendarIcon,
  EyeViewIcon,
  Pencil,
  VerticalThreeDot,
  EventDashbaord,
  LinkIcon,
  LocationIcon,
  AlarmIcon,
  AuthorIcon,
  JobLocationIcon,
  LinkIcons
} from '@mybridge/icons';
import moment from 'moment-timezone';
import Link from 'next/link';
import { isMobile, isTablet } from 'react-device-detect';
import { postDelete } from 'v4/store/actions/post.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import TruncatedTextWithTooltip from 'v4/components/common/Tooltip';
import DeleteEventPopup from 'v4/snippets/calendar/delete-event-modal';

const EventListBox = ({ event, type, isDeleted,upcomingFetchNextPage }) => {
  const { t } = useTranslator();
  const router = useRouter();
  const dispatch = useDispatch();
  const toast = useToast();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const currentLanguage = useSelector((state) => state.translation.language) || 'en';
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  useEffect(() => {
    if (currentLanguage === 'zh-cn') {
      moment.locale('zh-cn'); // Default to Simplified Chinese
    } else {
      moment.locale(currentLanguage);
    }
  }, [currentLanguage]);

  // const handleDeleteEvent = () => {
  //     dispatch(postDelete({ id: event?.id })).then((res) => {
  //       if (res) {
  //         toast({
  //           title: t('myEvents.eventDeletedSuccessfully') || 'Event deleted successfully',
  //           position: 'top',
  //           status: 'success',
  //           isClosable: true,
  //         });
  //         // setTabIndex(type==="past"?1:0)
  //         isDeleted(true);
  //         router.push(`/myevents`);
  //       }
  //     });
  //   };
    
const handleStartJoinMeeting=(event)=>{
  if(event?.location_type==="builtin"){
    router.push(`/myevents/join/${event.id}`)
  }else{
    window.open(event?.location)
  }
}

const cohost = event?.attendees?.find((user) => {
  return user.event_role === "cohost" && user?.id === userProfileInfo?.id
})
  
const isValidUrl = (url,type) => {
      if (type==="builtin")return true
      const urlPattern = new RegExp(
        '^(https?:\\/\\/)' + // Protocol must be present (http or https)
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // Domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // Port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // Query string
        '(\\#[-a-z\\d_]*)?$',
        'i'
      );       
      return urlPattern.test(url);
    };


  return (
    <>
      <Card mb={3} border="1px solid #E4E6EB" borderRadius="20px" width={isMobile ? "100%" : "45%"}>
        <CardBody pb={!event?.media?.[0]?.file? "30%" :"5%"} p="0px">
          {event?.media?.[0]?.file && (
            <Link
              href={
                type === 'past'
                  ? `/myevents/dashboard/${event?.id}`
                  : `/myevents/details/${event?.id}`
              }
            >
              <Image
                src={event?.media[0]?.file}
                alt={event.title}
                width="100%"
                maxW="100%"
                borderRadius="20px 20px 0 0"
              />
            </Link>
          )}
          <Stack mt="6" spacing="2" px={4} overflow="hidden">
            <Link
              href={
                // type === 'past'
                  // ? `/myevents/dashboard/${event?.id}`
                  // : 
                  `/myevents/details/${event?.id}`
              }
            >
              <Heading size="md" color="#3D5A80">
                {event?.title?.length>65?event?.title?.slice(0,65)+"...":event?.title}
              </Heading>
            </Link>

            <Flex align="center" gap="2">
              <CalendarIcon width="16px" height="16px" color="#9f9f9f" />
              <Text size="sm">
                {type === 'upcoming'
                  ? moment(event.start_time).calendar(null, {
                    sameDay: '[Today]',
                    nextDay: '[Tomorrow]',
                    nextWeek: 'dddd',
                    sameElse: 'MMM, DD YYYY',
                  })
                  : moment(event.start_time).local().format('MMM, DD YYYY')}
              </Text>
            </Flex>

            <Flex align="center" gap="2">
              <AlarmIcon width="16px" height="16px" color="#9f9f9f" />
              <Text size="sm">
                {moment(event.start_time).local().format('hh:mm A')} -{' '}
                {moment(event.end_time).local().format('hh:mm A zz')}
              </Text>
            </Flex>

            {event?.company?.address && (
              <Flex align="center" gap="2">
                <LocationIcon width="16px" height="16px" color="#9f9f9f" />
                <Text size="sm">{event?.company?.address}</Text>
              </Flex>
            )}

            <Flex align="center" >
              {event?.location_type === 'provide' ? (
                <Flex align="center" gap="2">
                  <JobLocationIcon
                    height={'18px'}
                    width={'18px'}
                    color="#9F9F9F"
                  />
                  <Text size="sm" isTruncated width="420px">
                    {event?.location}
                  </Text>
                </Flex>
              ) : (
                <Flex align="center" gap="2">
                  <LinkIcons
                    height={'18px'}
                    width={'18px'}
                    color="#9F9F9F"
                  />
                  <Link 
                    style={{color:'#5B5B5B'}}
                    href={event?.location_type === 'builtin' 
                      ? `${window?.location?.origin}/myevents/join/${event?.id}`
                      : event?.location ?? "#"}
                    {...(event?.location_type !== 'builtin' && { target: "_blank" })}
                  >
                    {/* <Text size="sm" isTruncated >
                      {event?.location_type === 'builtin'
                        ? `${window?.location?.origin}/myevents/join/${event?.id}`
                        : event?.location}
                    </Text> */}
                    <TruncatedTextWithTooltip 
                      text={event?.location_type === 'builtin'
                        ? `${window?.location?.origin}/myevents/join/${event?.id}`
                        : event?.location}
                      maxChars={isMobile ? 25 : isTablet ? 28 : 32}
                      fontSize="sm"
                      showTooltip={false}
                      style={{ cursor: 'pointer' }}
                    />
                  </Link>
                </Flex>
              )}
            </Flex>

            <Flex 
              onClick={() => { 
                if (event?.author?.slug) {
                  router.push(`/p/${event?.author?.slug}`);
                } else {
                  router.push(`/profile/me`);
                }
              }}
              cursor="pointer" 
              align="center" 
              gap="2"
            >
              <AuthorIcon />
              <Text size="sm">{event?.company?.name === "" ? event?.author?.display_name : event?.company?.name}</Text>
            </Flex>

          </Stack>
        </CardBody>
        <Divider />
        <CardFooter py={2}>
          <HStack w="100%" gap={0}>
            {/* Left-aligned buttons */}
            <HStack justifyContent="flex-start" gap={1}>
              <Tooltip label={t('myEvents.viewEventDetails') || "View event details"} bg="#5B5B5B">
                <IconButton
                  p={0}
                  variant="transparent"
                  icon={<EyeViewIcon width="16px" />}
                  onClick={() => router.push(`/myevents/details/${event.id}`)}
                />
              </Tooltip>

              {event?.author?.id === userProfileInfo?.id && type !== 'copy'&&type === 'upcoming'&& (
                <Tooltip label={t('buttons.edit') || "Edit"} bg="#5B5B5B">
                  <IconButton
                    p={0}
                    variant="transparent"
                    icon={<Pencil width="16px" />}
                    // onClick={() => router.push(`/myevents/edit/${event.id}`)}
                    onClick={() => router.push({
                      pathname: `/myevents/edit/${event.id}`,
                      query: { type: event?.event_type },
                    })}
                  />
                </Tooltip>
              )}

              {type === 'copy' && (
                <Button
                  onClick={() => router.push(`/myevents/copy/${event.id}`)}
                  size="sm"
                  variant="primary"
                  borderRadius="25px"
                >
                  {t('myEvents.copyThisEvent') || "Copy this event"}
                </Button>
              )}
              {type === 'upcoming' && isValidUrl(event.location??"", event.location_type) ? 
                ((event.author.id === userProfileInfo?.id) || cohost?.id ? (
                  <Button
                    size="sm"
                    variant="primary"
                    borderRadius="25px"
                    onClick={() => {handleStartJoinMeeting(event)
                      }}
                  >
                    {t('myEvents.start') || "Start"}
                  </Button>
                ) : (
                  <Button
                    size="sm"
                    variant="primary"
                    borderRadius="25px"
                    onClick={() => handleStartJoinMeeting(event)}
                  >
                    {t('myCalendar.join') || "Join"}
                  </Button>
                )
              ) : null}

              {/* {type !== 'copy' && (
                <Menu>
                  <MenuButton
                    as={IconButton}
                    aria-label="Options"
                    icon={<VerticalThreeDot height="19px" />}
                    variant="transparent"
                  />
                  <MenuList>
                    {type === 'past' &&
                      event.author.id === userProfileInfo?.id && (
                        <MenuItem>Duplicate</MenuItem>
                      )}
                  </MenuList>
                </Menu>
              )} */}
              {type !== 'copy' && (
                <Menu>
                  <MenuButton
                    as={IconButton}
                    aria-label="Options"
                    icon={<VerticalThreeDot height="19px" />}
                    variant="transparent"
                  />
                  <MenuList>
                    {event?.author?.id === userProfileInfo?.id && (
                      <MenuItem
                        onClick={() =>
                          router.push(`/myevents/dashboard/${event?.id}`)
                        }
                      >
                        {t('myEvents.eventDashboard') || "Event Dashboard"}
                      </MenuItem>
                    )}
                    {/* <MenuItem onClick={() => handleDeleteEvent()}>{t('buttons.delete') || "Delete"}</MenuItem> */}
                    <MenuItem onClick={() => setIsDeleteModalOpen(true)}>
                      {t('buttons.delete') || "Delete"}
                    </MenuItem>
                    {type === 'past' && event.author.id === userProfileInfo?.id && (
                      <MenuItem
                        onClick={() => router.push(`/myevents/copy/${event?.id}`)}
                      >
                        {t('advertising.duplicate') || "Duplicate"}
                      </MenuItem>
                    )}
                  </MenuList>
                </Menu>
              )}
            </HStack>

            {/* Spacer pushes dashboard button to the right */}
            <Spacer />

            {/* Right-aligned "View Dashboard" button */}
            {event?.author?.id === userProfileInfo?.id && (
              <Tooltip label={t('myEvents.viewDashboard') || "View dashboard"} bg="#5B5B5B">
                <IconButton
                  p={0}
                  variant="transparent"
                  icon={<EventDashbaord width="16px" color="#2E2E2A" />}
                  onClick={() => router.push(`/myevents/dashboard/${event.id}`)}
                />
              </Tooltip>
            )}
          </HStack>
        </CardFooter>
      </Card>
      <DeleteEventPopup
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        event={event}
        type={type}
        isDeleted={isDeleted}
      />
    </>
  );
};

export default EventListBox;
